// Traduções desta tela — coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'mapa.mapaPage.noCategory': 'Sem categoria',
    'mapa.mapaPage.loadPlacesError': 'Não foi possível carregar os locais',
    'mapa.mapaPage.layers': 'Camadas',
    'mapa.mapaPage.showLayers': 'Abrir camadas',
    'mapa.mapaPage.hideLayers': 'Fechar camadas',
    'mapa.rastro.botao': 'Rastro',
    'mapa.rastro.titulo': 'Rastro do veículo',
    'mapa.rastro.veiculo': 'Veículo',
    'mapa.rastro.semVeiculos': 'Nenhum veículo com rastreador vinculado.',
    'mapa.rastro.de': 'De',
    'mapa.rastro.ate': 'Até',
    'mapa.rastro.tracar': 'Traçar',
    'mapa.rastro.limpar': 'Limpar',
    'mapa.rastro.erro': 'Não foi possível buscar o trajeto. Tente de novo.',
    'mapa.rastro.vazio': 'Sem transmissões no período. A coleta do trajeto começou em 14/08/2026.',
    'mapa.rastro.truncado': 'Período com transmissões demais: o rastro mostra só o começo. Encurte o período.',
    'mapa.rastro.pontos_one': '{{count}} transmissão no período',
    'mapa.rastro.pontos_other': '{{count}} transmissões no período',
    'mapa.mapaPage.searchAriaLabel': 'Pesquisar na frota pesada',
    'mapa.mapaPage.clearSearch': 'Limpar pesquisa',
    'mapa.mapaPage.interactBlocked': 'Seu acesso ao mapa é somente leitura',
    'mapa.mapaPage.clusterAria_one': 'Grupo com {{count}} veículo. Clique para aproximar.',
    'mapa.mapaPage.clusterAria_other': 'Grupo com {{count}} veículos. Clique para aproximar.',
    'mapa.mapaPage.focusedContract': 'Contrato em foco',
    'mapa.mapaPage.focusedContractHint': 'No mapa ficam só este contrato, o destino dele e os veículos em atuação.',
    'mapa.mapaPage.places': 'Locais',
    'mapa.mapaPage.noPlacesWithCoordinates': 'Nenhum local com coordenada.',
    'mapa.mapaPage.placesCount_one': '{{count}} local com coordenada',
    'mapa.mapaPage.placesCount_other': '{{count}} locais com coordenada',
    'mapa.mapaPage.showPlaceCategory': 'Mostrar {{categoria}}',
    'mapa.mapaPage.loadsInRoute': 'Cargas em rota',
    'mapa.mapaPage.loadsCount_one': '{{count}} carga',
    'mapa.mapaPage.loadsCount_other': '{{count}} cargas',
    'mapa.mapaPage.showLoadsInRoute': 'Mostrar cargas em rota',
    'mapa.mapaPage.contracts': 'Contratos',
    'mapa.mapaPage.contractsCount_one': '{{count}} contrato · raio padrão de 1 km',
    'mapa.mapaPage.contractsCount_other': '{{count}} contratos · raio padrão de 1 km',
    'mapa.mapaPage.showContracts': 'Mostrar contratos e raio padrão de 1 km',
    'mapa.mapaPage.ubsGeofences': 'Cercas das UBS',
    'mapa.mapaPage.unitsCount_one': '{{count}} unidade',
    'mapa.mapaPage.unitsCount_other': '{{count}} unidades',
    'mapa.mapaPage.geofencePerPlace': 'cerca por local',
    'mapa.mapaPage.defaultRadius': 'raio padrão de 1 km',
    'mapa.mapaPage.showUbsGeofences': 'Mostrar as cercas das UBS',
    'mapa.mapaPage.trackedFleet': 'Frota pesada',
    'mapa.mapaPage.filteredVehiclesCount_one': '{{shown}} de {{count}} veículo',
    'mapa.mapaPage.filteredVehiclesCount_other': '{{shown}} de {{count}} veículos',
    'mapa.mapaPage.vehiclesCount_one': '{{count}} veículo',
    'mapa.mapaPage.vehiclesCount_other': '{{count}} veículos',
    'mapa.mapaPage.showTrackedFleet': 'Mostrar frota pesada',
    'mapa.mapaPage.tokenMissingTitle': 'Mapa não configurado',
    'mapa.mapaPage.tokenMissingBefore': 'Defina o token público do Mapbox (pk.*) em',
    'mapa.mapaPage.tokenMissingAfter': 'no runtime-config para exibir o mapa.',
    'mapa.busca.procurandoFora': 'Procurando locais fora da área visível…',
    'mapa.busca.nadaEncontrado': 'Nenhum dispositivo, local ou coordenada para esta pesquisa',
    'mapa.busca.placeholder': 'Local, coordenada, placa, motorista…',
    'mapa.busca.voarCoordenada': 'Voar até {{lat}}, {{lng}}',
    'mapa.busca.locais': 'Locais',
    'mapa.busca.contratos': 'Contratos',
    'mapa.busca.frota': 'Frota',
    'mapa.busca.localSemCoordenada': 'Sem coordenada cadastrada',
  },
  en: {
    'mapa.mapaPage.noCategory': 'Uncategorized',
    'mapa.mapaPage.loadPlacesError': 'Unable to load places',
    'mapa.mapaPage.layers': 'Layers',
    'mapa.mapaPage.showLayers': 'Open layers',
    'mapa.mapaPage.hideLayers': 'Close layers',
    'mapa.rastro.botao': 'Trail',
    'mapa.rastro.titulo': 'Vehicle trail',
    'mapa.rastro.veiculo': 'Vehicle',
    'mapa.rastro.semVeiculos': 'No vehicle with a linked tracker.',
    'mapa.rastro.de': 'From',
    'mapa.rastro.ate': 'To',
    'mapa.rastro.tracar': 'Trace',
    'mapa.rastro.limpar': 'Clear',
    'mapa.rastro.erro': 'Could not fetch the trail. Try again.',
    'mapa.rastro.vazio': 'No transmissions in the period. Trail collection started on 2026-08-14.',
    'mapa.rastro.truncado': 'Too many transmissions in the period: the trail shows only the beginning. Shorten the period.',
    'mapa.rastro.pontos_one': '{{count}} transmission in the period',
    'mapa.rastro.pontos_other': '{{count}} transmissions in the period',
    'mapa.mapaPage.searchAriaLabel': 'Search the heavy fleet',
    'mapa.mapaPage.clearSearch': 'Clear search',
    'mapa.mapaPage.interactBlocked': 'Your map access is read only',
    'mapa.mapaPage.clusterAria_one': 'Group with {{count}} vehicle. Click to zoom in.',
    'mapa.mapaPage.clusterAria_other': 'Group with {{count}} vehicles. Click to zoom in.',
    'mapa.mapaPage.focusedContract': 'Focused contract',
    'mapa.mapaPage.focusedContractHint': 'The map shows only this contract, its destination, and the active vehicles.',
    'mapa.mapaPage.places': 'Places',
    'mapa.mapaPage.noPlacesWithCoordinates': 'No places with coordinates.',
    'mapa.mapaPage.placesCount_one': '{{count}} place with coordinates',
    'mapa.mapaPage.placesCount_other': '{{count}} places with coordinates',
    'mapa.mapaPage.showPlaceCategory': 'Show {{categoria}}',
    'mapa.mapaPage.loadsInRoute': 'Loads in transit',
    'mapa.mapaPage.loadsCount_one': '{{count}} load',
    'mapa.mapaPage.loadsCount_other': '{{count}} loads',
    'mapa.mapaPage.showLoadsInRoute': 'Show loads in transit',
    'mapa.mapaPage.contracts': 'Contracts',
    'mapa.mapaPage.contractsCount_one': '{{count}} contract · default 1 km radius',
    'mapa.mapaPage.contractsCount_other': '{{count}} contracts · default 1 km radius',
    'mapa.mapaPage.showContracts': 'Show contracts and their default 1 km radius',
    'mapa.mapaPage.ubsGeofences': 'Unit geofences',
    'mapa.mapaPage.unitsCount_one': '{{count}} unit',
    'mapa.mapaPage.unitsCount_other': '{{count}} units',
    'mapa.mapaPage.geofencePerPlace': 'geofence per place',
    'mapa.mapaPage.defaultRadius': 'default 1 km radius',
    'mapa.mapaPage.showUbsGeofences': 'Show unit geofences',
    'mapa.mapaPage.trackedFleet': 'Heavy fleet',
    'mapa.mapaPage.filteredVehiclesCount_one': '{{shown}} of {{count}} vehicle',
    'mapa.mapaPage.filteredVehiclesCount_other': '{{shown}} of {{count}} vehicles',
    'mapa.mapaPage.vehiclesCount_one': '{{count}} vehicle',
    'mapa.mapaPage.vehiclesCount_other': '{{count}} vehicles',
    'mapa.mapaPage.showTrackedFleet': 'Show heavy fleet',
    'mapa.mapaPage.tokenMissingTitle': 'Map not configured',
    'mapa.mapaPage.tokenMissingBefore': 'Set the public Mapbox token (pk.*) in',
    'mapa.mapaPage.tokenMissingAfter': 'in runtime-config to display the map.',
    'mapa.busca.procurandoFora': 'Searching places outside the visible area…',
    'mapa.busca.nadaEncontrado': 'No device, place or coordinate matches this search',
    'mapa.busca.placeholder': 'Place, coordinate, plate, driver…',
    'mapa.busca.voarCoordenada': 'Fly to {{lat}}, {{lng}}',
    'mapa.busca.locais': 'Places',
    'mapa.busca.contratos': 'Contracts',
    'mapa.busca.frota': 'Fleet',
    'mapa.busca.localSemCoordenada': 'No coordinate registered',
  },
  es: {
    'mapa.mapaPage.noCategory': 'Sin categoría',
    'mapa.mapaPage.loadPlacesError': 'No se pudieron cargar los lugares',
    'mapa.mapaPage.layers': 'Capas',
    'mapa.mapaPage.showLayers': 'Abrir capas',
    'mapa.mapaPage.hideLayers': 'Cerrar capas',
    'mapa.rastro.botao': 'Rastro',
    'mapa.rastro.titulo': 'Rastro del vehículo',
    'mapa.rastro.veiculo': 'Vehículo',
    'mapa.rastro.semVeiculos': 'Ningún vehículo con rastreador vinculado.',
    'mapa.rastro.de': 'Desde',
    'mapa.rastro.ate': 'Hasta',
    'mapa.rastro.tracar': 'Trazar',
    'mapa.rastro.limpar': 'Limpiar',
    'mapa.rastro.erro': 'No fue posible buscar el trayecto. Intente de nuevo.',
    'mapa.rastro.vazio': 'Sin transmisiones en el período. La recolección del trayecto comenzó el 14/08/2026.',
    'mapa.rastro.truncado': 'Demasiadas transmisiones en el período: el rastro muestra solo el comienzo. Acorte el período.',
    'mapa.rastro.pontos_one': '{{count}} transmisión en el período',
    'mapa.rastro.pontos_other': '{{count}} transmisiones en el período',
    'mapa.mapaPage.searchAriaLabel': 'Buscar en la flota pesada',
    'mapa.mapaPage.clearSearch': 'Limpiar búsqueda',
    'mapa.mapaPage.interactBlocked': 'Su acceso al mapa es solo de lectura',
    'mapa.mapaPage.clusterAria_one': 'Grupo con {{count}} vehículo. Haz clic para acercar.',
    'mapa.mapaPage.clusterAria_other': 'Grupo con {{count}} vehículos. Haz clic para acercar.',
    'mapa.mapaPage.focusedContract': 'Contrato en foco',
    'mapa.mapaPage.focusedContractHint': 'El mapa muestra solo este contrato, su destino y los vehículos en operación.',
    'mapa.mapaPage.places': 'Lugares',
    'mapa.mapaPage.noPlacesWithCoordinates': 'No hay lugares con coordenadas.',
    'mapa.mapaPage.placesCount_one': '{{count}} lugar con coordenada',
    'mapa.mapaPage.placesCount_other': '{{count}} lugares con coordenada',
    'mapa.mapaPage.showPlaceCategory': 'Mostrar {{categoria}}',
    'mapa.mapaPage.loadsInRoute': 'Cargas en ruta',
    'mapa.mapaPage.loadsCount_one': '{{count}} carga',
    'mapa.mapaPage.loadsCount_other': '{{count}} cargas',
    'mapa.mapaPage.showLoadsInRoute': 'Mostrar cargas en ruta',
    'mapa.mapaPage.contracts': 'Contratos',
    'mapa.mapaPage.contractsCount_one': '{{count}} contrato · radio predeterminado de 1 km',
    'mapa.mapaPage.contractsCount_other': '{{count}} contratos · radio predeterminado de 1 km',
    'mapa.mapaPage.showContracts': 'Mostrar contratos y su radio predeterminado de 1 km',
    'mapa.mapaPage.ubsGeofences': 'Geocercas de las unidades',
    'mapa.mapaPage.unitsCount_one': '{{count}} unidad',
    'mapa.mapaPage.unitsCount_other': '{{count}} unidades',
    'mapa.mapaPage.geofencePerPlace': 'geocerca por lugar',
    'mapa.mapaPage.defaultRadius': 'radio predeterminado de 1 km',
    'mapa.mapaPage.showUbsGeofences': 'Mostrar las geocercas de las unidades',
    'mapa.mapaPage.trackedFleet': 'Flota pesada',
    'mapa.mapaPage.filteredVehiclesCount_one': '{{shown}} de {{count}} vehículo',
    'mapa.mapaPage.filteredVehiclesCount_other': '{{shown}} de {{count}} vehículos',
    'mapa.mapaPage.vehiclesCount_one': '{{count}} vehículo',
    'mapa.mapaPage.vehiclesCount_other': '{{count}} vehículos',
    'mapa.mapaPage.showTrackedFleet': 'Mostrar flota pesada',
    'mapa.mapaPage.tokenMissingTitle': 'Mapa no configurado',
    'mapa.mapaPage.tokenMissingBefore': 'Define el token público de Mapbox (pk.*) en',
    'mapa.mapaPage.tokenMissingAfter': 'en runtime-config para mostrar el mapa.',
    'mapa.busca.procurandoFora': 'Buscando lugares fuera del área visible…',
    'mapa.busca.nadaEncontrado': 'Ningún dispositivo, lugar o coordenada para esta búsqueda',
    'mapa.busca.placeholder': 'Lugar, coordenada, placa, conductor…',
    'mapa.busca.voarCoordenada': 'Volar hasta {{lat}}, {{lng}}',
    'mapa.busca.locais': 'Lugares',
    'mapa.busca.contratos': 'Contratos',
    'mapa.busca.frota': 'Flota',
    'mapa.busca.localSemCoordenada': 'Sin coordenada registrada',
  },
}
